import { translateContentToProps } from '../translation';

export const calcCurrentStep = (currentIndex, data, steps, content) => {
  let validStep = currentIndex;
  let defaultValues = steps[currentIndex].getDefaultValues(data);
  for (let index = currentIndex - 1; index >= 0; index--) {
    const indexDefaultValues = steps[index].getDefaultValues(data);
    if (!steps[index].schema.isValidSync(indexDefaultValues)) {
      defaultValues = indexDefaultValues;
      validStep = index;
    }
  }

  const nextStep = steps[validStep];
  const props = translateContentToProps(content);

  return {
    slug: nextStep.slug,
    defaultValues,
    props,
    extraProps: nextStep.getExtraProps?.(data) ?? {},
    component: nextStep.component,
    saveForm: nextStep.saveForm,
    index: validStep,
  };
};

export const allStepsValid = (data, steps) => {
  for (let step of steps) {
    if (!step.schema.isValidSync(step.getDefaultValues(data))) {
      return false;
    }
  }
  return true;
};

export const allPetsHaveProductInCart = (pets, cart) =>
  pets.every(pet => cart.line_items.find(item => item.pet_id === pet.id));

export const areAllStepsComplete = (pets, customer, steps) =>
  pets.every(pet => allStepsValid({ customer, pet }, steps));

export const getFirstPetWithIncompleteSteps = (pets, customer, steps) =>
  pets.find(pet => !allStepsValid({ customer, pet }, steps));

export const getFirstPetWithNoProductInCart = (pets, cart) =>
  pets.find(pet => !cart.line_items.find(item => item.pet_id === pet.id));
